import { clientTranslator } from '@adornis/translation-core/client/clientTranslator.js';
import { ValidationError } from '@adornis/validation/errors/ValidationError.js';

export const maxLength = (maxLength: number, props?: { translationKey?: string; allowFalsy?: boolean }) => options => {
  if (!props?.allowFalsy && !options.value) return;
  if (options.value && options.value.length > maxLength)
    throw new ValidationError(
      `Wert des Feldes "${
        clientTranslator.translate('field', options.key) as string
      }" darf nicht länger als ${maxLength} Zeichen sein!`,
      {
        key: options.key,
        path: options.path,
        translationKey: props?.translationKey,
      },
    );
};
